import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GestorService } from 'src/app/services/gestor.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { Overlay } from '@angular/cdk/overlay';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { PerfilService } from 'src/app/services/perfil.service';
import { OpcoesGestorInvitePaginado } from 'src/app/models/opcoes-gestor-invite-paginado';
import { Auth } from 'src/app/models/auth';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { PerfilNormalizado } from 'src/app/shared/enums/perfil-normalizado.enum';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { environment } from 'src/environments/environment';
import { GestorConvite } from 'src/app/models/gestor-convite';
import { SituacaoGestorConvite } from 'src/app/shared/enums/situacao-gestor-convite.enum';
import { CedenteGestor } from 'src/app/models/cedentegestor';
import { IMyDpOptions } from 'mydatepicker';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-gestor-aceito-list',
    templateUrl: './gestor-aceito-list.component.html',
    styleUrls: ["./gestor-aceito-list.component.css"]
})
export class GestorAceitoListComponent implements OnInit {

    public showItemInvite = '10';
    public currentPageInvite = 1;
    public sortOrder: boolean;
    public blockCount: number;
    public gestorConvites: GestorConvite[];
    public gestorConvitesList: GestorConvite[];
    public SituacaoGestorConvite = SituacaoGestorConvite;
    public gestorConviteToCancel: GestorConvite;
    public totalItemsInvite: number;
    public currentUser: Auth;
    public showContextMenu = true;
    public apenasGestorResponsavel = false;
    public gestoresCadastradosLabel = 'Gestores Cadastrados';
    public gestorLabel = 'Gestor';
    public gestoresLabel = 'Gestores';
    public permitirBuscarCPF = true;
    public permitirBuscarNome = true;
    public permitirBuscarStatus = true;
    public permitirBuscarCPFLike = true;
    public permitirBuscarNomeLike = true;

    // filters de convite
    public filtroNomeConvite: string;
    public filtroCPFConvite: string;
    public filtroEmailConvite: string;
    public filtroStatusConvite: string;
    public filtroValidadeConvite: Date;
    public searchConvite: string;
    public validadeConvite: any;

    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        minYear: 1901,
        maxYear: 2078,
        monthLabels: {
            1: 'Janeiro',
            2: 'Fevereiro',
            3: 'Março',
            4: 'Abril',
            5: 'Maio',
            6: 'Junho',
            7: 'Julho',
            8: 'Agosto',
            9: 'Setembro',
            10: 'Outubro',
            11: 'Novembro',
            12: 'Dezembro'
        },
        dayLabels: {
            su: 'Domingo',
            mo: 'Segunda',
            tu: 'Terça',
            we: 'Quarta',
            th: 'Quinta',
            fr: 'Sexta',
            sa: 'Sábado'
        }
    };

    constructor(
        private authenticationService: AuthenticationService,
        private gestorService: GestorService,
        private alertService: NewAlertService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        public overlay: Overlay,
        public viewContainerRef: ViewContainerRef,
        private parametrosDataService: ParametrosDataService,
        private perfilService: PerfilService) { }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.loadInvites();
        this.loadViewConfig();
    }

    loadViewConfig() {
        const parametros = this.parametrosDataService.currentParametrosValue;
        const perfis = this.perfilService.currentPerfisValue;

        this.showContextMenu = true;

        if (parametros) {
            if (parametros[ParametrosKey.apenasGestorResponsavelGerenciarGestores]) {
                this.apenasGestorResponsavel = BooleanConverter.getBoolean(parametros[ParametrosKey.apenasGestorResponsavelGerenciarGestores]);

                if (this.apenasGestorResponsavel) {
                    this.apenasGestorResponsavel = perfis.some(
                        x => x.nomeNormalizado === PerfilNormalizado.Responsavel
                    );
                }
            } else {
                this.apenasGestorResponsavel = false;
            }

            if (
                parametros[ParametrosKey.labelPersonalizadaGestoresCadastrados]
            ) {
                this.gestoresCadastradosLabel =
                    parametros[
                    ParametrosKey.labelPersonalizadaGestoresCadastrados
                    ];
            }

            if (parametros[ParametrosKey.labelPersonalizadaGestor]) {
                this.gestorLabel =
                    parametros[ParametrosKey.labelPersonalizadaGestor];
            }

            if (parametros[ParametrosKey.labelPersonalizadaGestores]) {
                this.gestoresLabel =
                    parametros[ParametrosKey.labelPersonalizadaGestores];
            }

            if (parametros[ParametrosKey.permitirMenuContexto]) {
                this.showContextMenu = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.permitirMenuContexto]
                );
            }

            if (parametros[ParametrosKey.permitirBuscaCPFGestores]) {
                this.permitirBuscarCPF = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.permitirBuscaCPFGestores]
                );
            }

            if (parametros[ParametrosKey.permitirBuscaNomeGestores]) {
                this.permitirBuscarNome = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.permitirBuscaNomeGestores]
                );
            }

            if (parametros[ParametrosKey.permitirBuscaStatusGestores]) {
                this.permitirBuscarStatus = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.permitirBuscaStatusGestores]
                );
            }

            if (parametros[ParametrosKey.permitirBuscaCPFIncrementalGestores]) {
                this.permitirBuscarCPFLike = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.permitirBuscaCPFIncrementalGestores]
                );
            }

            if (parametros[ParametrosKey.permitirBuscaNomeIncrementalGestores]) {
                this.permitirBuscarNomeLike = BooleanConverter.getBoolean(
                    parametros[ParametrosKey.permitirBuscaNomeIncrementalGestores]
                );
            }
        }
    }

    changePageInvite($event) {
        this.currentPageInvite = $event;
        this.loadInvites();
    }

    showItemChangedInvite(event) {
        this.showItemInvite = event;
        this.loadInvites();
    }

    getInviteOptions(): OpcoesGestorInvitePaginado {
        return new OpcoesGestorInvitePaginado(
            (this.currentPageInvite - 1) * +this.showItemInvite,
            +this.showItemInvite,
            this.filtroNomeConvite,
            this.filtroCPFConvite,
            this.filtroEmailConvite,
            this.filtroStatusConvite,
            this.filtroValidadeConvite,
            this.searchConvite
        );
    }

    searchFilterConvite(word: string) {
        this.searchConvite = word;
        this.loadInvites();
    }

    loadInvites() {

        const opcoes = this.getInviteOptions();

        this.gestorService
            .getAllInvitesPaginated(this.currentUser.token.assignorGuid, opcoes)
            .subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.gestorConvites = response.result.gestorConvites;
                        this.gestorConvitesList = response.result.gestorConvites;
                        this.totalItemsInvite = response.result.total;
                        for (const c of this.gestorConvitesList) {
                            const tam =
                                environment.TOTAL_CARACTERE_CPF -
                                c.cpf.toString().length;
                            let str = c.cpf.toString();
                            for (let i = 0; i < tam; i++) {
                                str = '0' + str;
                            }
                            c.cpf = str;
                        }
                        this.gestorConvitesList = this.gestorConvitesList.sort(
                            (a, b) =>
                                b.dataValidade
                                    .toString()
                                    .localeCompare(a.dataValidade.toString())
                        );
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error('Ocorreu um erro ao buscar as informações!');
                }
            );
    }

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    //#region OrderBy de Convite
    orderNomeConvite(item: GestorConvite[], sortOrder: boolean) {
        item.sort((a, b) => {
            let result = a.nome.toString().localeCompare(b.nome.toString(), undefined, { numeric: true });
            if (sortOrder) {
                result = b.nome.toString().localeCompare(a.nome.toString(), undefined, { numeric: true });
            }
            return result;
        });
    }

    orderCPFConvite(item: GestorConvite[], sortOrder: boolean) {
        item.sort((a, b) => {
            let result = a.cpf.toString().localeCompare(b.cpf.toString(), undefined, { numeric: true });
            if (sortOrder) {
                result = b.cpf.toString().localeCompare(a.cpf.toString(), undefined, { numeric: true });
            }
            return result;
        });
    }

    orderEmailConvite(item: GestorConvite[], sortOrder: boolean) {
        item.sort((a, b) => {
            let result = a.email.toString().localeCompare(b.email.toString(), undefined, { numeric: true });
            if (sortOrder) {
                result = b.email.toString().localeCompare(a.email.toString(), undefined, { numeric: true });
            }
            return result;
        });
    }

    orderStatusConvite(item: GestorConvite[], sortOrder: boolean) {
        item.sort((a, b) => {
            let result = a.situacaoConviteGestorDescricao.toString().localeCompare(b.situacaoConviteGestorDescricao.toString(), undefined, { numeric: true });
            if (sortOrder) {
                result = b.situacaoConviteGestorDescricao.toString().localeCompare(a.situacaoConviteGestorDescricao.toString(), undefined, { numeric: true });
            }
            return result;
        });
    }

    orderValidadeConvite(item: GestorConvite[], sortOrder: boolean) {
        item.sort((a, b) => {
            let result = a.dataValidade.toString().localeCompare(b.dataValidade.toString(), undefined, { numeric: true });
            if (sortOrder) {
                result = b.dataValidade.toString().localeCompare(a.dataValidade.toString(), undefined, { numeric: true });
            }
            return result;
        });
    }
    //#endregion


    // ApplyFilter de Convite
    applyFilterConvite(nome: string, cpf: string, email: string, status: string, validade: any) {
        this.filtroNomeConvite = nome;
        this.filtroCPFConvite = cpf;
        this.filtroEmailConvite = email;
        this.filtroStatusConvite = status;
        this.filtroValidadeConvite = null;
        if (validade) {
            this.filtroValidadeConvite = new Date(validade.date.year, validade.date.month - 1, validade.date.day);
        }

        this.loadInvites();
    }


    updateBlockCount() {
        // this.blockCount = this.cedenteGestor.filter(x => x.toBlock).length;
    }




    showCancelarConvite(content: any, gestorConvite: GestorConvite) {
        this.gestorConviteToCancel = gestorConvite;
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    cancelarconvite(gestorConvite: GestorConvite) {
        this.gestorService
            .cancelInvite(
                gestorConvite.gestorConviteGuid,
                this.currentUser.token.userReferenceId,
                this.currentUser.token.assignorGuid
            )
            .subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.alertService.success(response.message);
                        this.gestorConvitesList = this.gestorConvitesList.filter(
                            x =>
                                x.gestorConviteGuid !==
                                gestorConvite.gestorConviteGuid
                        );
                        this.gestorConvitesList.push(response.result);
                        this.gestorConvitesList = this.gestorConvitesList.sort(
                            (a, b) =>
                                b.dataValidade
                                    .toString()
                                    .localeCompare(a.dataValidade.toString())
                        );
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error('Ocorreu um erro ao buscar as informações!');
                }
            );
    }

}
